import { bcs } from "@iota/iota-sdk/bcs";
const Receipt = bcs.struct("Receipt", {
  RequestID: bcs.Address
});
const AssetsBag = bcs.struct("AssetsBag", {
  ID: bcs.Address,
  Size: bcs.u64()
});
const ReferentAssetsBag = bcs.struct("ReferentAssetsBag", {
  ID: bcs.Address,
  Value: bcs.option(AssetsBag)
});
const Anchor = bcs.struct("Anchor", {
  UID: bcs.Address,
  Assets: ReferentAssetsBag,
  StateMetadata: bcs.vector(bcs.u8()),
  StateIndex: bcs.u32()
});
const Message = bcs.struct("Message", {
  Contract: bcs.u32(),
  Function: bcs.u32(),
  Args: bcs.vector(bcs.vector(bcs.u8()))
});
const CoinAllowance = bcs.struct("CoinAllowance", {
  CoinType: bcs.string(),
  Balance: bcs.u64()
});
const Request = bcs.struct("Request", {
  UID: bcs.Address,
  Sender: bcs.Address,
  AssetsBag: ReferentAssetsBag,
  Message,
  Allowance: bcs.vector(CoinAllowance),
  GasBudget: bcs.u64()
});
const RequestEvent = bcs.struct("RequestEvent", {
  RequestID: bcs.Address,
  Anchor: bcs.Address
});
export {
  Anchor,
  AssetsBag,
  CoinAllowance,
  Message,
  Receipt,
  ReferentAssetsBag,
  Request,
  RequestEvent
};
//# sourceMappingURL=move_bcs.js.map
